import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../html/element'
import { Icon } from '../../../../html/icon'
import { InputDropdown } from '../../../../html/input/InputDropdown'
import { ScrollComponent } from '../../../../scrollComponent'
import Tree from '../../../../tree'
import { SCROLL_COMPONENT_IDS } from '../../../constant'
import {
  changeListParentChecked,
  handelRemoveIdParent,
  selectIndustry,
  selectListId,
} from '../../../store/sliceIndustry'
import { covertTagDataIndustry } from '../../helper'
import { LayoutContent } from '../layoutContent'

export const Industry = () => {
  const dispatch = useDispatch()

  const vsicTree = useSelector(selectIndustry('industryVSIC'))
  const listChecked = useSelector(selectIndustry('listChecked'))
  const listParentChecked = useSelector(selectIndustry('listParentChecked'))
  const data = useSelector(selectIndustry('industryVSICById'))

  const arrTagIndustry = covertTagDataIndustry(data, listParentChecked)

  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const [text, setText] = useState('')

  const onChange = (e) => {
    setText(e.target.value)
  }

  const handleOpenDropdown = () => {
    setIsShowDropdown(true)
  }

  const handleHideDropdown = () => {
    setIsShowDropdown(false)
    setText('')
  }

  const setListParentChecked = (value) => {
    dispatch(changeListParentChecked(value))
  }
  const setChecked = (value) => {
    dispatch(selectListId(value))
  }

  const handleDeleteIndustry = (item) => {
    dispatch(handelRemoveIdParent(item.value))
  }

  const renderDropdown = () => {
    return (
      <ScrollComponent autoHeight autoHeightMax={400}>
        <div style={{ paddingRight: 12 }}>
          <Tree
            treeData={vsicTree}
            idKey="id"
            nameKey="name"
            valueSearch={text || ''}
            listChecked={listChecked}
            setListChecked={setChecked}
            setListParentChecked={setListParentChecked}
            disabledCheckDbClick
            isHaveCheckbox
          />
        </div>
      </ScrollComponent>
    )
  }
  return (
    <div>
      <InputDropdown
        placeHolder="library.filterSetting.INDUSTRY_VSIC"
        value={text}
        onChange={onChange}
        isShowDropdown={isShowDropdown}
        setIsShowDropdown={setIsShowDropdown}
        onClickOutsideDropdown={handleHideDropdown}
        onClick={handleOpenDropdown}
        inputProps={{
          style: { fontSize: 12 },
          noControl: true,
          isShowIcon: false,
          customElement: (
            <Icon
              className="icon-caret-bottom pointerEventsNone"
              style={{
                fontSize: 8,
                left: 'unset',
                right: 4,
              }}
            />
          ),
        }}
        dropdownContainerStyle={{
          minWidth: 600,
          minHeight: 50,
        }}
        containerStyle={{ width: 200 }}
        dropdownContentStyle={{ paddingRight: 0 }}
        scrollId={SCROLL_COMPONENT_IDS}
      >
        {renderDropdown()}
      </InputDropdown>
      <Element
        elementName="p"
        style={{
          fontStyle: 'italic',
          padding: '4px 0',
        }}
      >
        {!!listParentChecked?.length && (
          <Translate
            value={`library.main.${
              !listParentChecked?.length || listParentChecked?.length < 2
                ? 'ITEM_SINGLE_SELECT'
                : 'ITEM_SELECT'
            }`}
            count={listParentChecked?.length}
          />
        )}
      </Element>
      <LayoutContent
        data={arrTagIndustry}
        onClickDelete={handleDeleteIndustry}
      />
    </div>
  )
}
